export default "__VITE_ASSET__AdD4E9jp__"